// src/api/gymReportes.js
// API para reportes del Gimnasio: Pagos detallados (Cashea, Pago Móvil, etc.) y Accesos
import { apiFetch } from './index.js';

/**
 * Obtiene el reporte financiero de pagos del gimnasio
 * @param {Object} filtros - { fecha_desde, fecha_hasta, metodo_pago, idTipoMembresia, busqueda }
 */
export const obtenerReportePagosGym = async (filtros = {}) => {
  try {
    const params = new URLSearchParams();

    if (filtros.fecha_desde) params.append('fecha_desde', filtros.fecha_desde);
    if (filtros.fecha_hasta) params.append('fecha_hasta', filtros.fecha_hasta);
    if (filtros.metodo_pago && filtros.metodo_pago !== 'todos') {
      params.append('metodo_pago', filtros.metodo_pago);
    }
    if (filtros.idTipoMembresia) params.append('idTipoMembresia', filtros.idTipoMembresia);
    if (filtros.busqueda && filtros.busqueda.trim() !== '') {
      params.append('busqueda', filtros.busqueda.trim());
    }

    const qs = params.toString() ? `?${params.toString()}` : '';
    const response = await apiFetch(`/Membresia/reportes/pagos${qs}`);

    return {
      success: true,
      data: response.data || response,
      resumen: response.resumen || response.data?.resumen || {},
      pagos: response.pagos || response.data?.pagos || []
    };
  } catch (error) {
    console.error('❌ Error obteniendo reporte de pagos gym:', error);
    return {
      success: false,
      error: error.message,
      resumen: {},
      pagos: []
    };
  }
};

/**
 * Obtiene el reporte histórico de accesos del gimnasio
 * @param {Object} filtros - { documento, resultado, tipo_metodo, idSede, fecha_desde, fecha_hasta, busqueda }
 */
export const obtenerReporteAccesosGym = async (filtros = {}) => {
  try {
    const payload = {
      documento: filtros.documento || null,
      resultado: (filtros.resultado && filtros.resultado !== 'todos') ? filtros.resultado : null,
      tipo_metodo: (filtros.tipo_metodo && filtros.tipo_metodo !== 'todos') ? filtros.tipo_metodo : null,
      idSede: filtros.idSede ? parseInt(filtros.idSede) : null,
      fecha_desde: filtros.fecha_desde ? `${filtros.fecha_desde}T00:00:00` : null,
      fecha_hasta: filtros.fecha_hasta ? `${filtros.fecha_hasta}T23:59:59` : null,
      busqueda: filtros.busqueda && filtros.busqueda.trim() !== '' ? filtros.busqueda.trim() : null
    };

    const response = await apiFetch('/Membresia/accesos/search', {
      method: 'POST',
      body: JSON.stringify(payload)
    });

    const data = Array.isArray(response) ? response : (response.data || []);
    return {
      success: true,
      data,
      count: data.length
    };
  } catch (error) {
    console.error('❌ Error obteniendo reporte de accesos gym:', error);
    return {
      success: false,
      error: error.message,
      data: [],
      count: 0
    };
  }
};

export default {
  obtenerReportePagosGym,
  obtenerReporteAccesosGym
};

